import { render, staticRenderFns } from "./festivalNav.vue?vue&type=template&id=2e2c0251&scoped=true"
import script from "./festivalNav.vue?vue&type=script&lang=js"
export * from "./festivalNav.vue?vue&type=script&lang=js"
import style0 from "./festivalNav.vue?vue&type=style&index=0&id=2e2c0251&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e2c0251",
  null
  
)

export default component.exports